import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../services/api"; // Assuming you have an api module to make API requests
import { PHARMACY_LIST } from "../../services/urls"; // Assuming you have a URL for fetching teams
import { setPharmacyId } from "../../utils/commonFunctions";

// Initial state
const initialState = {
  phamracyList: [],
};

// Async thunk to fetch teams
export const myPharmacyList = createAsyncThunk(
  "pharmacy/myPharmacyList", // Action type prefix
  async (updateStorage = true, { rejectWithValue }) => {
    try {
      const response = await api.get(PHARMACY_LIST);
      if (response?.data?.data?.length && updateStorage) {
        setPharmacyId(response?.data?.data[0]._id)
      }
      return response.data.data; // Assuming your API response contains the teams data
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch teams"
      );
    }
  }
);

// Create slice
const pharmacySlice = createSlice({
  name: "pharmacy",
  initialState,
  reducers: {
    clearPharmacyList: (state) => {
      state.phamracyList = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(myPharmacyList.fulfilled, (state, action) => {
      state.phamracyList = action.payload;
    });
  },
});
export const { clearPharmacyList } = pharmacySlice.actions;
// Export the reducer
export default pharmacySlice.reducer;
